SA.localize = function(msg) {
    if (msg && SA.Institution && SA.Institution.getLocale() === 'CAN') {
        msg = msg
            .replace(/(c)olor/gi, '$1olour')
            .replace(/(c)enter/gi, '$1entre')
            .replace(/(f)avorite/gi, '$1avourite')
            .replace(/(m)eter/gi, '$1etre')
            .replace(/(b)ehavior/gi, '$1ehaviour')
            .replace(/(n)eighbor/gi, '$1eighbour')
            .replace(/\b(m)odeled\b/gi, '$1odelled')
            .replace(/\b(m)odeling\b/gi, '$1odelling');
    }

    return msg;
};